import { withRightPopupProvider } from "./context";
import { PlacementWorksheetRightPopup as View } from "./PlacementWorksheetRightPopup";

export const PlacementWorksheetRightPopup = withRightPopupProvider(View);
